/**
 * Fixes accessibility issues related to Moray Tabs
 * @see https://moray-prod.azurewebsites.net/components/detail/tab--standard.html
 **/

/**
 * Manages tab state on page load. This fixes an isssue where if a hash pointing
 * to a tab is present in the URL, the active tab does not correctly set
 * aria-selected.
 */
const maybeSetInitialActiveTab = () => {
	const tabs = document.querySelectorAll( '.tab-link-item' );

	// If there are no tabs, bail.
	if ( ! tabs.length ) {
		return;
	}

	tabs.forEach( ( tab ) => {
		const isActive = tab.classList.contains( 'active' );
		tab.setAttribute( 'aria-selected', isActive );
	} );

};

/**
 * Fixes accessibility issues related to Moray Tabs
 */
export default function MorayTabsA11y() {
	maybeSetInitialActiveTab();
}
